import TutorialBar from './tutorialBar.js';
export default TutorialBar;
